<template>
  <div align="center">
    <page-header></page-header>
    <table width="98%" border="0" cellpadding="0" cellspacing="0" class="table_green" bgcolor="#e7f3d6">
      <tbody>
        <tr>
          <td width="10" height="25">&nbsp;</td>
          <td width="100%" align="left" valign="middle">
            <img src="../../assets/img/jt.jpg" width="9" height="9" />
            {{$t('currlocation')}}:<router-link to="{name:'login'}">{{$t('index')}}</router-link>
            <img src="../../assets/img/jt.gif" />
            {{$t('company')}}
          </td>
        </tr>
      </tbody>
    </table>
    <!--当前位置结束-->
    <p></p>
    <p></p>
    <!--正文表格开始-->
    <div align="center">
      <form>
        <table width="608" border="0" cellpadding="1" cellspacing="1" class="main_talbe">
          <!--DWLayoutTable-->
          <tbody>

            <tr class="trtitle">
              <td height="22" colspan="3" align="center" valign="middle">
                {{$t('inquiry')}}
              </td>
            </tr>
            <tr>
              <td width="151" height="30" align="right" valign="middle" class="tr2">
                {{$t('company_inquiryby')}}&nbsp;:
              </td>
              <td width="100" align="left" valign="middle" class="tr3">&nbsp;<input name="inqtypeby" type="radio" @click="Querybyοnchange('Consol')" value="consol" checked>
                {{$t('company_consol')}}
              </td>
              <td width="357" align="left" valign="middle" class="tr3">&nbsp;<input type="radio" name="inqtypeby" @click="Querybyοnchange('AWB')" value="house">
                {{$t('company_house')}}
              </td>
            </tr>
            <tr>
              <td height="30" align="right" valign="middle" class="tr2">
                {{$t('normal_inqtype')}}&nbsp;:
              </td>
              <td align="left" valign="middle" class="tr3">&nbsp;<input name="inqtype" type="radio" @click="QueryType('A')" value="air" checked>
                {{$t('normal_air')}}
              </td>
              <td align="left" valign="middle" class="tr3">&nbsp;<input type="radio" name="inqtype" @click="QueryType('S')" value="sea">
                {{$t('normal_sea')}}&nbsp;
              </td>
            </tr>
            <tr>
              <td height="30" align="right" valign="middle" class="tr2">
                {{$t('normal_inq_etd')}}:&nbsp;
              </td>
              <td align="left" valign="middle" class="tr3" colspan="2">&nbsp;
                <input name="etd" type="text" id="data_WdatePicker" v-model="searchData.CreateDate" size="16" v-on:click="datePicker('data_WdatePicker')">
                -- &nbsp;&nbsp;
                <input name="etd_end" type="text" v-model="searchData.EndDate" size="16" id="end_WdatePicker" v-on:click="enddatePicker('end_WdatePicker')">
              </td>
            </tr>
            <tr>
              <td height="30" align="right" valign="middle" class="tr2">
                {{$t('normal_word1')}}:&nbsp;
              </td>
              <td align="left" valign="middle" class="tr3" colspan="2">&nbsp;
                <select name="codetype" v-model="selectType">
                  <option value="1" selected>
                    {{$t('company_masterno')}}
                  </option>
                  <option value="2">
                    {{$t('company_houseno')}}
                  </option>
                </select>
              </td>
            </tr>
            <tr>
              <td rowspan="2" align="right" valign="top" class="tr2"><br>
                {{$t('inputno')}}:&nbsp;
              </td>
              <td height="86" align="left" valign="middle" class="tr3" colspan="2">&nbsp;
                <textarea name="code" cols="24" rows="4" id="code" v-model="No"></textarea>
              </td>
            </tr>
            <tr align="center" valign="middle">
              <td height="28" align="left" valign="middle" class="tr3" colspan="2">
                <input type="button" name="Submit" :value="$t('submit')" @click="search()"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <input type="reset" name="reset" :value="$t('reset')">
              </td>
            </tr>
          </tbody>
        </table>
      </form>
    </div>
    <p></p>
    <p></p>
    <page-footer></page-footer>
  </div>
</template>
<script>
import PageFooter from "@/components/infrastructure/layout/page-footer.vue";
import PageHeader from "@/components/infrastructure/layout/page-header.vue";

import { SelectBranchBillOfLading } from "@/api/branchBillOflading";
export default {
  components: {
    PageHeader,
    PageFooter,
  },
  data() {
    return {
      searchData: {
        BillType: "",
        CreateDate: "",
        EndDate: "",
        QueryBy: "Consol",
        HouseNo: "",
        AwbBlType: "A",
        MasterNo: "",
        Row: 50,
        Page: 1,
      },
      selectType: "1",
      No: "",
    };
  },
  methods: {
    Querybyοnchange(name) {
      this.searchData.QueryBy = name;
    },
    QueryType(name) {
      this.searchData.AwbBlType = name;
    },
    search() {
      if (this.selectType == "1") {
        this.searchData.MasterNo = this.No;
        this.searchData.HouseNo = "";
      } else {
        this.searchData.HouseNo = this.No;
        this.searchData.MasterNo = "";
      }
      console.log(this.searchData);
      this.$router.push({
        name: "branch-bill-of-lading-query-list",
        query: {
        info: JSON.stringify({
          BillType: this.searchData.BillType,
          CreateDate: this.searchData.CreateDate,
          EndDate: this.searchData.EndDate,
          QueryBy: this.searchData.QueryBy,
          HouseNo: this.searchData.HouseNo,
          AwbBlType: this.searchData.AwbBlType,
          MasterNo: this.searchData.MasterNo,
          Row: this.searchData.Row,
          Page: this.searchData.Page,
          })
        },
      });
      // console.log(this.searchData);
      //      const _this = this;
      //       await SelectBranchBillOfLading(this.searchData)
      //       .then((res) => {
      //       //  console.log("进来了成功方法")
      //         // localStorage.setItem("token",res.data.token);
      //         // //console.log(localStorage.getItem("token"))
      //         // _this.SET_LOGIN_USER(res.data);
      //         //   _this.$router.push({ path: "home" });
      //         if (res.code!=200) {
      //           _this.errors = res.message;

      //         } else {
      //           localStorage.setItem("token",res.data.token);
      //           _this.SET_LOGIN_USER(res.data);
      //           _this.$router.push({ path: "home" });
      //         }
      //       })
      //       .catch((error) => {
      //         console.error(error);
      //       });
    },
    datePicker: function (elementId) {
      let vueObj = this;
      WdatePicker({
        el: elementId,
        dateFmt: "yyyy-MM-dd", //日期格式，可以只显示年或年月，也可以额外显示时间
        onpicked: function () {
          var value = $("#" + elementId).val();
          vueObj.searchData.CreateDate = value;
        },
        oncleared: function () {
          vueObj.searchData.CreateDate = null;
        },
        isShowClear: true,
        readOnly: true,
      });
    },
    enddatePicker: function (elementId) {
      let vueObj = this;
      WdatePicker({
        el: elementId,
        dateFmt: "yyyy-MM-dd", //日期格式，可以只显示年或年月，也可以额外显示时间
        onpicked: function () {
          var value = $("#" + elementId).val();
          vueObj.searchData.EndDate = value;
        },
        oncleared: function () {
          vueObj.searchData.EndDate = null;
        },
        isShowClear: true,
        readOnly: true,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/index.css";
</style>